function decodeBase64(input) {
  return typeof window === 'undefined'
    ? Buffer.from(input, 'base64').toString('ascii')
    : window.atob(input)
}

export default decodeBase64
